import React from 'react'

import Button from '@dashboard/components/Button'
import Card from '@dashboard/components/Card'
import CardHeader from '@dashboard/components/CardHeader'

import Trait from '../Trait'

import { ColorIconName, Datum } from '@dashboard/lib/types'

import Link from 'next/link'

import css from './styles.module.scss'

interface OwnProps {
  icon: ColorIconName
  paywallCta?: {
    text: string
    href?: string
    showSampleLink?: boolean
    onClick?: () => void
  }
  paywallText?: string
  title: string
  content?: Array<{ id: string; text: string }> | Datum[]
  discType: string
  id?: string
}
interface State {
  randomPhrases: Array<string>
}

export default class Section extends React.Component<OwnProps, State> {
  constructor(props: OwnProps) {
    super(props)

    this.state = {
      randomPhrases: [],
    }
  }

  componentDidMount() {
    this._setRandomTraits()
  }

  render() {
    const { icon, title, discType } = this.props

    return (
      <Card noPadding>
        <CardHeader icon={icon} title={title} discType={discType} />

        {this.renderContent()}
      </Card>
    )
  }

  renderContent() {
    const { content } = this.props

    if (content) return this.renderSection()
    else return this.renderRandomSection()
  }

  renderSection() {
    const { content } = this.props

    if (!content) return null

    return (
      <div className={css.wrapper}>
        <div>
          {(content.slice(0, 4) as { id: string; text: string }[]).map(
            phrase => {
              return <Trait key={phrase.text} text={phrase.text} noEndorse />
            },
          )}
        </div>
      </div>
    )
  }

  renderRandomSection() {
    const { paywallText, paywallCta } = this.props

    return (
      <div className={css.wrapper}>
        <div className={css.paywalled}>{this.renderRandomTraits()}</div>
        <div className={css.paywall}>
          <div className={css.circle}>
            <img src="/static/share/images/group_fit.svg" />
          </div>
          <div
            className={css.paywallText}
            dangerouslySetInnerHTML={{ __html: paywallText || '' }}
          />

          <Button onClick={this.handleClick}>{paywallCta?.text || ''}</Button>
          {this.renderSampleLink()}
        </div>
      </div>
    )
  }

  renderRandomTraits() {
    const { randomPhrases } = this.state

    return (
      <div>
        {randomPhrases.map(phrase => (
          <Trait key={phrase} text={phrase} />
        ))}
      </div>
    )
  }

  renderSampleLink() {
    const { paywallCta } = this.props

    if (!paywallCta?.showSampleLink) return null

    return (
      <Link
        href="/p/bill-gates?show_as_own=true"
        target="_blank"
        rel="noopener noreferrer"
        className={css.sampleLink}
        passHref
      >
        View sample
      </Link>
    )
  }

  // Functions
  _setRandomTraits = () => {
    const randomText = [
      'Lorem ipsum dolor sit amet, consectetur',
      'Excepteur sint occaecat cupidatat non proident',
      'Sunt in culpa qui officia deserunt mollit anim id est laborum',
      'Officia deserunt mollit anim id est laborum',
      'Sed do eiusmod tempor incididunt ut labore et dolore magna aliqua',
      'Quis nostrud exercitation ullamco laboris nisi ut',
      'In reprehenderit in voluptate velit',
    ].sort(function () {
      return 0.5 - Math.random()
    })

    this.setState({ randomPhrases: randomText })
  }

  handleClick = () => {
    const { paywallCta, id } = this.props
    const search = id ? `?profile_id=${id}` : ''

    if (paywallCta?.href)
      window.location.href = paywallCta.href || `/app/register${search}`
    else if (paywallCta?.onClick) paywallCta.onClick()
  }
}
